import React, { PureComponent } from 'react';
import styles from './FileUpload.module.css';
import Dropzone from 'react-dropzone';
import Divider from '../Divider';
import Checkbox from 'rc-checkbox';
import ReactSelect from 'react-select';

export default class FileUpload extends PureComponent {
  state = {
    renderPreview: true,
  };

  uploadFile = () => {
    const el = this.refs['fileUpload'];
    el.click();
  };

  handleFileUpload = (ev, f) => {
    const { allowType, onFileUpload } = this.props;
    const file = (f && f[0]) || (ev.target.files && ev.target.files[0]);
    if (!file) return;
    if (allowType && file.type !== allowType) {
      this.setState({ error: 'unsupported file format' });
      return;
    }
    if (onFileUpload) {
      onFileUpload(file);
    }

    this.setState({ file, error: null });
  };

  cancelUpload = e => {
    const { onCancel } = this.props;
    if (onCancel) {
      onCancel();
    }
  };

  render() {
    const { error, file, renderPreview } = this.state;
    const {
      onUpload,
      navTo,
      title,
      header,
      type,
      filenote,
      hidenBtn,
      dropZone,
      previewOption,
      format,
      changeFormat,
    } = this.props;
    return (
      <div className={styles.container}>
        {header && <div className={styles.header}>{header}</div>}
        <div className={styles.spreadsheet}>
          {title && (
            <div className={styles.title}>
              {title}
              <span className={styles.require}>required</span>
            </div>
          )}
          {format && (
            <ReactSelect
              className={styles.select}
              options={[
                { label: 'FBX Format', value: 'fbx' },
                { label: 'glTF format', value: 'gltf' },
                { label: 'Vrscenezip format', value: 'vrscenezip' },
              ]}
              value={format}
              onChange={changeFormat}
            />
          )}
          <button className={styles.choosefile} onClick={this.uploadFile}>
            Choose file
          </button>
          <span className={styles.filenote}>{filenote}</span>
          <input
            type="file"
            ref="fileUpload"
            onChange={this.handleFileUpload}
            style={{ display: 'none' }}
          />
          {dropZone && (
            <Dropzone
              className={styles.dropZone}
              onDrop={file => this.handleFileUpload(null, file)}
            >
              <p className={styles.dropTxt}>Or drop file here</p>
            </Dropzone>
          )}
          <div
            className={file && file.name ? styles.addedTitle : styles.title}
            style={{ marginTop: 20 }}
          >
            File added
          </div>
          {error && <span className={styles.errorTxt}>{error}</span>}
          <div>{file && file.name}</div>
        </div>
        {previewOption && (
          <div className={styles.preview}>
            <Checkbox
              checked={renderPreview}
              className={styles.rowCheck}
              onChange={e => this.setState({ renderPreview: !renderPreview })}
            />
            Render previews when upload finishes
          </div>
        )}
        {!hidenBtn && (
          <div className={styles.action}>
            <button
              className={styles.upload}
              onClick={() => onUpload(type, file, { renderPreview })}
            >
              Upload
            </button>
            <a className={styles.cancel} onClick={this.cancelUpload}>
              Cancel
            </a>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FileUpload/index.js